import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { clearUserData, getNewStateByAttr, getNewStateById } from './entities';
import { fetchFantasyEvents } from './fantasyEvents';
import { fetchTickets, editPropBetTicket } from './tickets';
const initialState = {
    byId: {},
    byTicketId: {},
    status: 'init'
};
export const fetchSelections = createAsyncThunk('selections/fetch', async (ticketId, thunkApi) => {
    try {
        return await (await api.instance).fetchSelections(ticketId);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
const applyNewSelectionsState = (state, selections) => {
    state.byId = getNewStateById(state.byId, selections);
    state.byTicketId = getNewStateByAttr(state.byId, 'ticketId');
};
const selectionsSlice = createSlice({
    name: 'selections',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(clearUserData.fulfilled, (state) => (state = initialState))
            .addCase(fetchSelections.fulfilled, (state, action) => {
            applyNewSelectionsState(state, action.payload);
            state.status = 'success';
        })
            .addCase(fetchTickets.fulfilled, (state, action) => {
            applyNewSelectionsState(state, action.payload.selections);
        })
            .addCase(fetchFantasyEvents.fulfilled, (state, action) => {
            if (action.payload.selections) {
                applyNewSelectionsState(state, action.payload.selections);
            }
        })
            .addCase(fetchSelections.pending, (state) => {
            state.status = 'fetching';
        })
            .addCase(fetchSelections.rejected, (state) => {
            state.status = 'error';
        })
            .addCase(editPropBetTicket.fulfilled, (state, action) => {
            action.meta.arg.deletedSelectionIds.forEach((deletedSelectionId) => {
                delete state.byId[deletedSelectionId];
            });
            applyNewSelectionsState(state, action.payload);
        });
    }
});
export const selectionsReducer = selectionsSlice.reducer;
